import React from "react"
import { DialogProvider } from "@hg/dialog-sdk"
import { DialogManagerWrapper } from "./features/index"
import { defaultDialogConfig } from "./config"
import type { DialogConfig } from "./types"

interface DialogRootProps {
    children?: React.ReactNode
    config?: DialogConfig
}

export const DialogRoot: React.FC<DialogRootProps> = ({ children, config }) => {
    const mergedConfig = { ...defaultDialogConfig, ...config }

    return (
        <DialogProvider config={mergedConfig}>
            {children}
            <DialogManagerWrapper />
        </DialogProvider>
    )
}

export * from "./hooks"
export * from "./types"
